import {isTask} from '@domain/shifthandover'
import {CommentCounter} from '@hconnect/common/comments'
import {OverdueLabel} from '@hconnect/common/components/eventProperties/OverdueLabel'
import {ShiftEvent} from '@hconnect/common/types'
import {mergeSxs} from '@hconnect/uikit/src/lib2'
import {useUpmPlantNow} from '@hconnect/upm'
import {Box, Typography, SxProps, Theme} from '@mui/material'
import {EventTypeLabel, EventStatusLabel} from '@widgets/common-shift-event'
import React from 'react'

import {PriorityIcon} from '../components'
import {getHighlightedEventSx, eventRowSx} from '../styles'

export type Props = {
  plantId: string
  sx?: SxProps<Theme>
  'data-test-id'?: string
  item: ShiftEvent
  onClick: (item: ShiftEvent) => void
}

export const EventSummaryComponent: React.FC<Props> = ({
  plantId,
  item,
  onClick,
  'data-test-id': dataTestId,
  sx
}) => {
  const getPlantNow = useUpmPlantNow(plantId)
  return (
    <Box
      sx={mergeSxs(
        (theme: Theme) => ({
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          alignItems: 'center',
          minHeight: theme.spacing(6),
          padding: theme.spacing(0, 2, 0, 2)
        }),
        [eventRowSx(), Boolean(item.isHighlighted) && getHighlightedEventSx()],
        sx
      )}
      onClick={() => onClick(item)}
      data-test-id={dataTestId}
    >
      <Box display={'flex'} flex={1} alignItems="start" pt={0.5} pb={0.5}>
        <Box display={'flex'} alignItems="start" flex={1}>
          <Box width={28} display={'flex'} flexShrink={0} justifyContent={'flex-end'} pr={0.25}>
            {'priority' in item && item.priority && item.priority <= 2 && (
              <PriorityIcon priority={item.priority} />
            )}
          </Box>
          <EventTypeLabel
            eventType={item.eventType}
            iconOnly
            sx={{
              flexShrink: 0,
              pr: 1,
              minHeight: 24
            }}
          />
          <Typography
            sx={[
              {
                flexGrow: 1,
                overflow: 'hidden',
                overflowWrap: 'anywhere'
              }
            ]}
            variant={'h5'}
          >
            {item.title}{' '}
            {isTask(item) && (
              <OverdueLabel status={item.status} dueDate={item.dueDate} plantNow={getPlantNow()} />
            )}
          </Typography>
        </Box>
        <EventStatusLabel
          status={item.status}
          sx={{
            flexShrink: 0,
            height: 20
          }}
        />

        <CommentCounter id={item.id} count={item.commentCount} sx={{ml: 1.5, minWidth: 44}} />
      </Box>
    </Box>
  )
}
